/* eslint-disable camelcase */
import { AnyAction, CombinedState, combineReducers } from 'redux';

import profile from './profile_store';
import notification from './notification_store';
import flash_messages_notification from './flash_message_notification_store';
import undoToast from './undo_toast_store';
import new_notification from './new_notification_store';
import panel from './panel_store';
import menus_behaviour from './menus_behaviour_store';
import monitoring from './monitoring_store';
import userPreferences from './user_preferences_store';
import monitoringPreferences from './monitoring_preferences_store';
import servicesSubscriptions from './service_subscription_store';
import onlineSearch from './online_search_store';
import followupOnlineSearch from './followup_online_search_store';
import biddings from './bidding_store';
import followups from './followup_store';
import plans from './plans_store';
import additionalServices from './additional_services_store';
import selectedPlan from './selected_plan_store';
import aiSummary from './summary_ai';
import simulate from './simulate_store';
import update_sale from './update_sales_store';
import create_sale from './create_sales_store';
import simulate_all from './simulate_all_store';
import parcelamento from './get_package_service_store';
import proportional_sale from './proportional_sale_simulation_store';
import get_imminence from './get_dados_imminence_store';
import userContacts from './user_contacts_store';
import atas from './ata_registration_price_store';
import management from './management_store';
import documents from './documents_store';
import contracts from './contracts_store';
import my_history from './my_history_store';
import bulletins from './bulletins_store';
import my_account from './my_account_store';
import course from './course_store';
import market from './market_store';
import concurrents from './concurrents_store';
import tools_status from './tools_status';
import juridico from './juridico_facil_store';
import dica_legal from './consultancy_legal_store';
import progression_course from './progression_course_store';
import activities from './activities_store';
import chatbot_assistant from './chatbot_assistant_store';
import portals_manager from './portals_manager_store';
import bidding_chat from './bidding_chat';
import dr_licita from './dr_licita_store';
import bidding_summary from './bidding_summary_store';
import conlicitaseg from './conlicitaseg_store';
import register from './register_store';
import contract_analysis from './contract_analysis';
import central_ia from './central_ia';
import academy from './academy_store';
import ai_management from './ai_management_store';
import { AdditionalServicesState } from './additional_services_store/types';
import { BiddingState } from './bidding_store/types';
import { CreateSaleState } from './create_sales_store/types';
import { FlashMessagesNotificationState } from './flash_message_notification_store/types';
import { FollowupState } from './followup_store/types';
import { MenusBehaviourState } from './menus_behaviour_store/types';
import { MonitoringState } from './monitoring_store/types';
import { NewNotificationState } from './new_notification_store/types';
import { NotificationState } from './notification_store/types';
import { OnlineSearchState } from './online_search_store/types';
import { PanelState } from './panel_store/types';
import { PlansState } from './plans_store/types';
import { AiSummaryState } from './summary_ai/types';
import { ProfileState } from './profile_store/types';
import { SelectedPlansState } from './selected_plan_store/types';
import { ServicesSubscriptionState } from './service_subscription_store/types';
import { SimulateState } from './simulate_store/types';
import { UpdateSaleState } from './update_sales_store/types';
import { UserContactsState } from './user_contacts_store/types';
import { UserPreferencesState } from './user_preferences_store/types';
import { MonitoringPreferencesState } from './monitoring_preferences_store/types';
import { ManagementState } from './management_store/types';
import { SimulateAllState } from './simulate_all_store/types';
import { ParcelamentoServicesState } from './get_package_service_store/types';
import { ProportionalSaleState } from './proportional_sale_simulation_store/types';
import { ImminenceState } from './get_dados_imminence_store/types';
import { ContractsState } from './contracts_store/types';
import { AtasState } from './ata_registration_price_store/types';
import { MyHistoryState } from './my_history_store/types';
import { DocumentsState } from './documents_store/types';
import { BulletinsState } from './bulletins_store/types';
import { MyAccountState } from './my_account_store/types';
import { CourseState } from './course_store/types';
import { ProgressionCourseState } from './progression_course_store/types';
import { FollowupOnlineSearchState } from './followup_online_search_store/types';
import { MarketState } from './market_store/types';
import { ConcurrentsState } from './concurrents_store/types';
import { ToolsStatusState } from './tools_status/types';
import { JuridicoFacilState } from './juridico_facil_store/types';
import { ChatbotAssistantState } from './chatbot_assistant_store/types';
import { ConsultancyLegalState } from './consultancy_legal_store/types';
import { ActivitiesState } from './activities_store/types';
import { BiddingChatState } from './bidding_chat/types';
import { BiddingSummaryState } from './bidding_summary_store/types';
import { DrLicitaState } from './dr_licita_store/types';
import { PortalsManagerState } from './portals_manager_store/types';
import { ConlicitasegState } from './conlicitaseg_store/types';
import { RegisterState } from './register_store/types';
import { ContractsAnalysisState } from './contract_analysis/types';
import { CentralIaState } from './central_ia/types';
import { UndoToastState } from './undo_toast_store/types';
import { AcademyState } from './academy_store/types';
import { AiManagementState } from './ai_management_store/types';

const combined = combineReducers({
  profile,
  notification,
  flash_messages_notification,
  undoToast,
  new_notification,
  panel,
  menus_behaviour,
  monitoring,
  userPreferences,
  monitoringPreferences,
  servicesSubscriptions,
  onlineSearch,
  followupOnlineSearch,
  biddings,
  followups,
  plans,
  additionalServices,
  aiSummary,
  selectedPlan,
  simulate,
  update_sale,
  create_sale,
  userContacts,
  atas,
  management,
  simulate_all,
  parcelamento,
  proportional_sale,
  get_imminence,
  contracts,
  my_history,
  documents,
  bulletins,
  my_account,
  course,
  progression_course,
  market,
  concurrents,
  tools_status,
  juridico,
  chatbot_assistant,
  dica_legal,
  activities,
  bidding_chat,
  dr_licita,
  portals_manager,
  bidding_summary,
  conlicitaseg,
  register,
  contract_analysis,
  central_ia,
  academy,
  ai_management,
});

const rootReducer = (
  state:
    | CombinedState<{
        profile: ProfileState;
        notification: NotificationState;
        flash_messages_notification: FlashMessagesNotificationState;
        undoToast: UndoToastState;
        new_notification: NewNotificationState;
        panel: PanelState;
        menus_behaviour: MenusBehaviourState;
        monitoring: MonitoringState;
        userPreferences: UserPreferencesState;
        monitoringPreferences: MonitoringPreferencesState;
        servicesSubscriptions: ServicesSubscriptionState;
        onlineSearch: OnlineSearchState;
        followupOnlineSearch: FollowupOnlineSearchState;
        biddings: BiddingState;
        followups: FollowupState;
        plans: PlansState;
        additionalServices: AdditionalServicesState;
        selectedPlan: SelectedPlansState;
        simulate: SimulateState;
        update_sale: UpdateSaleState;
        create_sale: CreateSaleState;
        userContacts: UserContactsState;
        management: ManagementState;
        documents: DocumentsState;
        simulate_all: SimulateAllState;
        parcelamento: ParcelamentoServicesState;
        proportional_sale: ProportionalSaleState;
        get_imminence: ImminenceState;
        contracts: ContractsState;
        atas: AtasState;
        my_history: MyHistoryState;
        bulletins: BulletinsState;
        my_account: MyAccountState;
        course: CourseState;
        progression_course: ProgressionCourseState;
        market: MarketState;
        concurrents: ConcurrentsState;
        tools_status: ToolsStatusState;
        juridico: JuridicoFacilState;
        chatbot_assistant: ChatbotAssistantState;
        dica_legal: ConsultancyLegalState;
        activities: ActivitiesState;
        bidding_chat: BiddingChatState;
        dr_licita: DrLicitaState;
        campaign_simulation: ProportionalSaleState;
        portals_manager: PortalsManagerState;
        bidding_summary: BiddingSummaryState;
        conlicitaseg: ConlicitasegState;
        register: RegisterState;
        aiSummary: AiSummaryState;
        contract_analysis: ContractsAnalysisState;
        central_ia: CentralIaState;
        academy: AcademyState;
        ai_management: AiManagementState;
      }>
    | undefined,
  action: AnyAction,
) => {
  if (action.type === 'CLEAR_REDUX') {
    console.log('CLEAR_REDUX');
    state = undefined;
  }

  return combined(state, action);
};

export default rootReducer;
